export default __webpack_public_path__ + "static/media/newyear.95682dc5.jpg";